import React, { useState, useCallback, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';

//Bootstrap
import { Row, Col } from 'react-bootstrap';

//Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify, faYoutube, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faMicrophoneAlt, faVideo, faNewspaper } from '@fortawesome/free-solid-svg-icons';

import './ProductItem.css';

const heightWindow = window.innerHeight;

const ProductItem = (props) => {
    const article = props.article ? <FontAwesomeIcon icon={faNewspaper} className="mr-2 custom-icon-title" title="Artículo" /> : null;
    const video = props.video ? <FontAwesomeIcon icon={faVideo} className="mr-2 custom-icon-title" title="Video" /> : null;
    const audio = props.audio ? <FontAwesomeIcon icon={faMicrophoneAlt} className="mr-2 custom-icon-title" title="Audio" /> : null;
    const [visible, setVisible] = useState(false);

    const handleVisible = useCallback(() => {
        if (visible === false) {
            const posTopElement = document.getElementById(props.id).getBoundingClientRect().y;
            const posBottomElement = posTopElement + (document.getElementById(props.id).getBoundingClientRect().height / 5);
            if ((heightWindow) > (posBottomElement)) {
                setVisible(true);
                window.removeEventListener('scroll', handleVisible, true);
            }
        }
    }, [props.id, visible]);

    useEffect(() => {
        setVisible(heightWindow > (document.getElementById(props.id).getBoundingClientRect().y + (document.getElementById(props.id).getBoundingClientRect().height / 5)));
    }, [props.id]);

    useEffect(() => {
        window.addEventListener('scroll', handleVisible, true);
        return (() => {
            window.removeEventListener('scroll', handleVisible, true);
        });
    }, [handleVisible]);
    return (
        <Row id={props.id} name={props.id} className={visible ? "custom-visible custom-transition-scale pt-4 px-md-5 mx-md-5 my-4 justify-content-center" : "custom-visible-hidden pt-4 px-md-5 mx-md-5 my-4 justify-content-center"}>
            <Col md="6" lg="4" xl="3" className="px-xl-4 pt-2">
                <div className="overflow-hidden">
                    <div className="custom-img-scale">
                        <Link to={{ pathname: props.pathname, state: { id: props.id } }}>
                            <img src={props.img} alt={props.alt} style={{width: '100%'}} className="img-fluid" />
                        </Link>
                    </div>
                </div>
            </Col>
            <Col md="6" lg="7" xl="5" className="pt-3 pt-md-0">
                <h3>
                    <NavLink to={{ pathname: props.pathname }} className="custom-title-link custom-text-black custom-font-weight-bolder">{props.title}</NavLink>
                </h3>
                <p className="custom-description-404 mb-2">{props.date}</p>
                <p className="mb-3">
                    {props.typeSelected === 0 ?
                        <React.Fragment>
                            <span className="badge custom-badge-blue py-1 px-2 text-uppercase custom-max-content custom-float-start">{props.type}</span>
                            <span className="custom-float-end">
                                {article}
                                {video}
                                {audio}
                            </span>
                            <br />
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {article}
                            {video}
                            {audio}
                        </React.Fragment>
                    }
                </p>
                <p className="custom-description">{props.description}</p>
                {props.spotify ?
                    <div className="d-inline">
                        <a href={props.linkSpotify} target="_blank" rel="noopener noreferrer" className="btn custom-btn-green mr-3 my-2">
                            <FontAwesomeIcon icon={faSpotify} className="mr-2" style={{ fontSize: '16px' }} />
                            Spotify
                        </a>
                    </div>
                    : null}
                {props.youtube ?
                    <div className="d-inline">
                        <a href={props.linkYoutube} target="_blank" rel="noopener noreferrer" className="btn custom-btn-white mr-3 my-2">
                            <FontAwesomeIcon icon={faYoutube} className="mr-2" style={{ fontSize: '16px', color: '#ff0000' }} />
                            Youtube
                        </a>
                    </div>
                    : null}
                {props.instagram ?
                    <div className="d-inline">
                        <a href={props.linkInstagram} target="_blank" rel="noopener noreferrer" className="btn custom-btn-pink mr-3 my-2">
                            <FontAwesomeIcon icon={faInstagram} className="mr-2" style={{ fontSize: '16px' }} />
                            Instagram
                        </a>
                    </div>
                    : null}
            </Col>
        </Row>
    );
};

export default ProductItem;